<template>
    <div class="excavate-complex">
        <analysisOption @option_click='option_click'> </analysisOption>
        <div class="excavate-table">
            <el-table
                :data='complexList'
                :header-cell-style="{background:'#a7754f',color:'#fff'}"
                size='mini'
                border
                default-expand-all>
                <el-table-column
                    width="240px"
                    label="类型"
                    prop="typeName"
                >
                </el-table-column>
                <el-table-column
                    prop="description"
                    label="说明">
                </el-table-column>
            </el-table>
        </div>
        <el-form class="mar-top20">
            <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="10">
                    <el-form-item label="类型："  label-width="60px">
                        <el-select  class="complex-select" size='mini' v-model="graphType"  placeholder="请选择类型">
                            <el-option
                                v-for="item in complexOptins"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="3">
                     <el-button  type="primary" size="small" @click='complex_click'>复杂网络分析</el-button>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
import analysisOption from "./comps/analysis_option.vue"
import excavateData from './comps/excavateData.js'
export default {
    components: {
        analysisOption,
    },
    data () {
        return {
            // 和组件内部的值保持统一
            beforeRadio:'clinicalFeature',
            beforeValue:'临床表现',
            afterRadio:'clinicalFeature',
            afterValue:'临床表现',
            complexList:excavateData.complexList,
            // 类型默认普通关系
            graphType:'0001',
            complexOptins:excavateData.complexOptins,
        }
    },
     methods: {
        // 获取选择后的值
        option_click(params){
            if(params.type=='before'){
                this.beforeRadio = params.val;
                this.beforeValue=params.valName
            }else if(params.type=='after'){
                this.afterRadio = params.val;
                this.afterValue=params.valName
            }
        },
        // 复杂网络分析
        complex_click(){
            // return
            // this.$router.push({
            //     path:'detailsComplex',
            //     query:{
            //         beforeValue:this.beforeValue,
            //         afterValue:this.afterValue,
            //     }
            // }) 
            let optionLable ='';
            if(this.beforeRadio==this.afterRadio){
                optionLable=this.beforeRadio
            }else{
                optionLable=`${this.beforeRadio},${this.afterRadio}`
            }
            this.$router.push({
                path:'detailsComplex',
                query:{
                    optionLable,
                    beforeValue:this.beforeValue,
                    afterValue:this.afterValue,
                    graphType:this.graphType,
                }
            }) 
        },
    }
}
</script>

<style>

</style>